import i18n from '@/i18n';
import { STATUS_OPEN, STATUS_CLOSED } from '@/constants';
import { useCruiseManagementStore } from '@/store/CruiseManagementStore';
import { useCruiseStore } from '@/store/CruiseStore';
import { useIndexStore } from '@/store/IndexStore';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';

export function useCruiseComposable() {
  const userAuthorizationsStore = useUserAuthorizationsStore();
  const authorizations: any = userAuthorizationsStore.permissionByRole;

  const cruiseType = {
    DESTINATION: 'DESTINATION',
    LINE: 'LINE',
    SHIP: 'SHIP',
    SAILING: 'SAILING'
  };
  const updateCruiseStatus = (id, status: string, type) => {
    const cruiseManagementStore = useCruiseManagementStore();
    const cruiseStore = useCruiseStore();
    cruiseManagementStore
      .updateStatus(id, {
        sts: status === STATUS_OPEN,
        type
      })
      .then(() => {
        cruiseStore.getCruise();
        const store = useIndexStore();
        store.updateSuccessNotification({ message: i18n.global.t('notification.save_successfully') });
      });
  };
  const handleOpenChangeRole = (status: string) => {
    return (status === STATUS_OPEN && !authorizations?.configurationPage?.cruise_deactive) || (!authorizations?.configurationPage?.cruise_active && (status === STATUS_CLOSED || status === null));
  };
  return {
    cruiseType,
    updateCruiseStatus,
    handleOpenChangeRole
  };
}
